module.exports = __webpack_public_path__ + "img/arrow--up.486a9275.svg";